import {AbstractControl, AsyncValidatorFn, ValidationErrors} from "@angular/forms";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

export class AsyncNotMatchValidator {
    static createValidator(strings: Observable<string[]>, message?: string, isCaseSensitive?: boolean): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> => {
            return strings
                .pipe(
                    map((strings: string[]) => {
                            const flatStrings = strings.map(s => s.toLowerCase())
                            if (isCaseSensitive ? strings.includes(control.value) : flatStrings.includes(control.value?.toLowerCase())) {
                                return {notMatchError: true, message}
                            } else {
                                return null
                            }
                        }
                    )
                );
        };
    }
}
